module.exports = __webpack_public_path__ + "img/bg-login-vdash.cbcb3dc1.jpg";